export const stations = [
    {
        name: "Matsapha Police Station",
        type: "POLICE",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
    {
        name: "Siteki Government Hospital",
        type: "MEDIC",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
    {
        name: "Siteki Government Hospital",
        type: "MEDIC",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
    {
        name: "Siteki Government Hospital",
        type: "MEDIC",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
    {
        name: "Siteki Government Hospital",
        type: "MEDIC",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
    {
        name: "Matsapha Police Station",
        type: "POLICE",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },

    {
        name: "Nhlangano Fire Station",
        type: "FIRE",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },

    {
        name: "Mbabane Government Hospital",
        type: "MEDIC",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
    {
        name: "Manzini Police Station",
        type: "POLICE",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
    {
        name: "Nhlangano Police Station",
        type: "POLICE",
        location: "32.1313, 13.1313",
        phone_number: "7648 0479"
    },
]